import Main from '@/views/Main.vue'
import practise from '@/views/practise.vue'

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: '登录 - 源码熊人工智能教育平台 '
  },
  // component: () => import('@/views/login.vue')
  component: () => import('@/views/index.vue')
}
// export const indexPage = {
//   path: '/index',
//   name: 'index',
//   meta: {
//     title: '让每个孩子都有机会学习编程 '
//   },
//   component: () => import('@/views/index.vue')
// }
export const activateRouter = {
  path: '/ULogin',
  name: 'ULogin',
  meta: {
      title: '激活 - 源码熊人工智能教育平台'
  },
  component: () => import('@/views/activate.vue')
}
export const passRouter = {
  path: '/pass',
  name: 'pass',
  meta: {
      title: '新版 - 源码熊人工智能教育平台'
  },
  component: () => import('@/views/pass.vue')
}
export const newSideRouter = {
  path: '/new-side',
  name: 'new-side',
  meta: {
      title: '新版 - 源码熊人工智能教育平台'
  },
  component: () => import('@/views/newSide.vue')
}
export const zkactivateRouter = {
  path: '/zkactivate',
  name: 'zkactivate',
  meta: {
      title: '激活 - 源码熊人工智能教育平台'
  },
  component: () => import('@/views/zkactivate.vue')
}
export const classCodeLoginRouter = {
  path: '/classCodeLogin',
  name: 'classCodeLogin',
  meta: {
      title: '班级码登录 - 源码熊人工智能教育平台'
  },
  component: () => import('@/views/classCodeLogin.vue')
}
export const uniqueLoginRouter = {
  path: '/uniqueLogin',
  name: 'uniqueLogin',
  meta: {
      title: '专属登录 - 源码熊人工智能教育平台'
  },
  component: () => import('@/views/uniqueLogin.vue')
}
export const activateTRouter = {
  path: '/ULoginT',
  name: 'ULoginT',
  meta: {
      title: '激活 - 源码熊人工智能教育平台'
  },
  component: () => import('@/views/activateTrial.vue')
}
export const accountEnd = {
  path: '/accountEnd',
  name: 'accountEnd',
  meta: {
      title: '账号到期 - 源码熊人工智能教育平台'
  },
  component: () => import('@/views/accountEnd.vue')
}
export const ULoginNeedLoginRouter = {
  path: '/ULoginNeedLogin',
  name: 'ULoginNeedLogin',
  meta: {
      title: '重新登录 - 源码熊人工智能教育平台'
  },
  component: () => import('@/views/ULoginNeedLogin.vue')
};
export const registRouter = {
  path: '/regist',
  name: 'regist',
  meta: {
    title: '注册 - 源码熊人工智能教育平台'
  },
  component: () => import('@/views/regist.vue')
}
export const opusDetailRouter = {
  path: '/opus-detail',
  name: 'opus-detail',
  meta: {
    title: '源码熊人工智能教育平台 - 作品详情'
  },
  component: () => import('@/views/index-page/opusDetail.vue')
}
export const articalDetailRouter = {
  path: '/artical-detail',
  name: 'artical-detail',
  meta: {
    title: '源码熊人工智能教育平台 - 编程小新星'
  },
  component: () => import('@/views/index-page/articalDetail.vue')
}
export const showScratchRouter = {
  path: '/peixun/showScratch',
  name: 'showScratch',
  meta: {
    title: '源码熊图形化'
  },
  component: () => import('@/views/peixun/showScratch.vue')
}
export const showPythonRouter = {
  path: '/peixun/showPython',
  name: 'showPython',
  meta: {
    title: '源码熊Python'
  },
  component: () => import('@/views/peixun/showPython.vue')
}

export const showPDF = {
  path: '/showPDF',
  name: 'showPDF',
  meta: {
    title: '源码熊课程'
  },
  component: () => import('@/views/peixun/showPDF.vue')
}
export const showPDF2 = {
  path: '/showPDF2',
  name: 'showPDF2',
  meta: {
    title: '源码熊课程'
  },
  component: () => import('@/views/peixun/showPDF2.vue')
}
export const middlePageRouter = {
  path: '/practise',
  name: 'practise',
  meta: {
    title: '源码熊题库'
  },
  component: () => import('@/views/practise.vue')
}
export const knowledgeStrong = {
  path: '/knowledgeStrong',
  name: 'knowledgeStrong',
  meta: {
    title: '源码熊题库-知识点强化'
  },
  component: () => import('@/views/practise/knowledgeStrong.vue')
}
export const knowledgeStrongPractise = {
  path: '/knowledgeStrongPractise',
  name: 'knowledgeStrongPractise',
  meta: {
    title: '源码熊题库-知识点强化练习'
  },
  component: () => import('@/views/practise/knowledgeStrongPractise.vue')
}
export const questionBank = {
  path: '/questionBank',
  name: 'questionBank',
  meta: {
    title: '源码熊题库-题库列表'
  },
  component: () => import('@/views/practise/questionBank.vue')
}
export const testStore = {
  path: '/testStore',
  name: 'testStore',
  meta: {
    title: '源码熊题库-题库练习'
  },
  component: () => import('@/views/practise/testStore.vue')
}
export const simulationTest = {
  path: '/simulationTest',
  name: 'simulationTest',
  meta: {
    title: '源码熊题库-模拟测验'
  },
  component: () => import('@/views/practise/simulationTest.vue')
}
export const simulationTestDetail = {
  path: '/simulationTestDetail',
  name: 'simulationTestDetail',
  meta: {
    title: '源码熊题库-模拟测验详情'
  },
  component: () => import('@/views/practise/simulationTestDetail.vue')
}
export const errorCollection = {
  path: '/errorCollection',
  name: 'errorCollection',
  meta: {
    title: '源码熊题库-我的错题集'
  },
  component: () => import('@/views/practise/errorCollection.vue')
}
export const myExam = {
  path: '/myExam',
  name: 'myExam',
  meta: {
    title: '源码熊题库-我的考试'
  },
  component: () => import('@/views/practise/myExam.vue')
}

export const page403 = {
  path: '/403',
  meta: {
    title: '403-权限不足'
  },
  name: 'error-403',
  component: () => import('@/views/error-page/403.vue')
}

export const page500 = {
  path: '/500',
  meta: {
    title: '500-服务端错误'
  },
  name: 'error-500',
  component: () => import('@/views/error-page/500.vue')
}

// export const locking = {
//   path: '/locking',
//   name: 'locking',
//   component: () => import('@/views/main-components/lockscreen/components/locking-page.vue')
// }

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: '/',
  name: 'otherRouter',
  redirect: '/home',
  component: Main,
  children: [
    { path: 'home', title: '首页', name: 'home_index', component: () => import('@/views/home/home.vue') },
    { path: 'opusSquare', title: '作品广场', name: '', component: () => import('@/views/student/opusSquare.vue') },
    { path: 'myOpus', title: '我的作品', name: '', component: () => import('@/views/student/myOpus.vue') },
    { path: 'task-customer', title: '编程挑战', name: 'task-customer_index', component: () => import('@/views/peixun/stepByStepProgram.vue') },
    { path: 'myClassmate', title: '我的同学', name: '', component: () => import('@/views/student/myClassmate.vue') },
    { path: 'myCollection', title: '我的收藏', name: '', component: () => import('@/views/student/myCollection.vue') },
    { path: 'myClassmate/opus', title: '我的同学作品', name: 'myClassmateOpus', component: () => import('@/views/student/myClassmateOpus.vue') },
    { path: 'userCenter', title: '用户中心', name: 'ownspace_index', component: () => import('@/views/student/userCenter.vue') },
    { path: 'opusDetail', title: '作品详情', name: 'opusDetail', component: () => import('@/views/student/opusDetail.vue') },
    { path: 'activityDetail', title: '活动详情', name: 'activityDetail', component: () => import('@/views/student/activityDetail.vue') },
    { path: 'myStudyCommen', title: '参考资料', name: 'tb-myStudyCommen', component: () => import('@/views/student/myStudyCommen.vue') },
    { path: 'courseList', title: '课程列表', name: 'tb-courseList', component: () => import('@/views/student/courseList.vue') },
    { path: 'upMember', title: '会员升级', name: 'tb-upMember', component: () => import('@/views/student/upMember.vue') },
    { path: 'change-pass', title: '修改密码', name: 'change_pass', component: () => import('@/views/change-pass/change-pass.vue') },
    { path: 'message', title: '消息中心', name: 'message_index', component: () => import('@/views/message/message.vue') },
    { path: 'student/openCoursePage', title: '公开课', name: 'openCoursePage', component: () => import('@/views/student/openCoursePage.vue') },
    { path: 'student/activityPage', title: '创作活动', name: 'activityPage', component: () => import('@/views/student/activityPage.vue') },
    { path: 'student/classmateDynamicPage', title: '同学动态', name: 'classmateDynamicPage', component: () => import('@/views/student/classmateDynamicPage.vue') },
    { path: 'student/myCoursePage', title: '我的课程', name: 'tb-myCoursePage', component: () => import('@/views/student/myCoursePage.vue') },
    { path: 'student/newOpusPage', title: '最新作品', name: 'tb-newOpusPage', component: () => import('@/views/student/newOpusPage.vue') },
    { path: 'student/goodsOpusPage', title: '推荐优秀作品', name: 'tb-goodsOpusPage', component: () => import('@/views/student/goodsOpusPage.vue') },

    // {
    //   path: 'createPicText',
    //   title: '新建素材',
    //   name: 'createPicText',
    //   component: () => import('../views/student/createPicText.vue')
    // }
    // {
    //   path: 'messageDetail',
    //   title: '消息详情',
    //   name: 'messageDetail',
    //   component: () => import('@/views/peixun/messageManage/messageSendDetail.vue')
    // },
    // {
    //   path: 'addMessage',
    //   title: '添加新消息',
    //   name: 'addMessage',
    //   component: () => import('@/views/peixun/messageManage/addOrEditMessage.vue')
    // }
    // {
    //     path: '/peixun/fullScreenPdf',
    //     name: 'fullScreenPdf',
    //     meta: {
    //         title: 'pdf'
    //     },
    //     component: () => import('@/views/peixun/fullScreenPdf.vue')
    // }
  ]
}


export const fullScreenPdf = {
  path: '/peixun/fullScreenPdf',
  name: 'fullScreenPdf',
  meta: {
      title: '源码熊人工智能教育平台'
  },
  component: () => import('@/views/peixun/fullScreenPdf.vue')
};
export const appRouter = []
export const tkOtherRouter={
  path: '/',
  name: 'tkOtherRouter',
  redirect: '/practise',
  component: practise,
  children:[
    { path: 'knowledgeStrong', title: '知识点强化', name: 'knowledgeStrong', component: () => import('@/views/practise/knowledgeStrong.vue') },
    { path: 'knowledgeStrongPractise', title: '知识点强化练习', name: 'knowledgeStrongPractise', component: () => import('@/views/practise/knowledgeStrongPractise.vue') },
    { path: 'questionBank', title: '题库列表', name: 'questionBank', component: () => import('@/views/practise/questionBank.vue') },
    { path: 'testStore', title: '题库练习', name: 'testStore', component: () => import('@/views/practise/testStore.vue') },
    { path: 'simulationTest', title: '模拟测验', name: 'simulationTest', component: () => import('@/views/practise/simulationTest.vue') },
    { path: 'simulationTestDetail', title: '模拟测验详情', name: 'simulationTestDetail', component: () => import('@/views/practise/simulationTestDetail.vue') },
    { path: 'errorCollection', title: '我的错题集', name: 'errorCollection', component: () => import('@/views/practise/errorCollection.vue') },
    { path: 'myExam', title: '我的错题集', name: 'myExam', component: () => import('@/views/practise/myExam.vue') },
  ]
}
// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  loginRouter,
  otherRouter,
  tkOtherRouter,
  ...appRouter,
  page500,
  page403,
  registRouter,
  opusDetailRouter,
  articalDetailRouter,
  showScratchRouter,
  showPythonRouter,
  // showCourseRouter,
  showPDF,
  showPDF2,
  fullScreenPdf,
  middlePageRouter,
  knowledgeStrong,
  knowledgeStrongPractise,
  questionBank,
  testStore,
  simulationTest,
  simulationTestDetail,
  errorCollection,
  myExam,
  activateRouter,
  zkactivateRouter,
  passRouter,
  classCodeLoginRouter,
  newSideRouter,
  uniqueLoginRouter,
  activateTRouter,
  accountEnd,
  ULoginNeedLoginRouter,
  // recordingCourse
]



// WEBPACK FOOTER //
// ./src/router/router.js